// extracted by mini-css-extract-plugin
module.exports = {"isCopiedContainer":"IsCopiedMessage_isCopiedContainer__3f0e9","active":"IsCopiedMessage_active__2kyw6"};